import * as _ from 'lodash';
import { useEffect, useRef } from 'react';
import { Alert } from 'react-bootstrap';

import useGetUserMasquerade from '../../../hooks/api/masquerade/useGetUserMasquerade';
import useUnmask from '../../../hooks/api/masquerade/useUnmask';
import Button from '../Button/Button';
import { BUTTON_TYPE } from '../Button/button-constants';
import Icon, { icons, IconText } from '../Icon';

/**
 * Lol
 */
const MasqueradeBanner = () => {
  // declare show state
  const { data } = useGetUserMasquerade();
  const { mutate: unmask } = useUnmask();
  const prevUserIdRef = useRef<number | null | undefined>(undefined);

  // Refresh page when masquerade session ends
  useEffect(() => {
    const currentUserId = data?.userId ?? null;
    const prevUserId = prevUserIdRef.current;

    // If we were masquerading (had a userId) and now we're not (null), refresh
    if (!_.isNil(prevUserId) && currentUserId === null) {
      window.location.reload();
    }

    prevUserIdRef.current = currentUserId;
  }, [data?.userId]);

  if (!data) {
    return null;
  }

  return (
    <Alert bsStyle="neworg">
      <Icon icon={icons.mask} /> Warning: You are masquerading as {data.username} ({data.userId}).{' '}
      <Button
        onClick={async () => {
          await unmask();
          window.location.reload();
        }}
        type={BUTTON_TYPE.OUTLINE_LIGHT}
      >
        <IconText icon={icons.userXMark} text="Unmask" />
      </Button>
    </Alert>
  );
};

export default MasqueradeBanner;
